import React from 'react'
import "../words_about_us/WordsAboutUs.css"
const WordsAboutUs = () => {
  return (
    <>
         <section id="words_about_us">
        <div class="container">
            <div class="row">
                <div class="col-lg-5 words_about_us_img">
                    <img src="imeges/Desktop-3/basket.png" class="w-100" alt=""/>
                </div>
                <div class="col-lg-6">
                    <div class="words_about_us_text">
                        <h6>A Few Words About Us</h6>
                        <h1>A shop for good people <br/>
                            by good people</h1>
                    <p>Buy natural, sustainable and chemicalfree products from local sellers across the country. <br/>
                        We are a strong community of 100,000+ customers and 600+ sellers who aspire to be good, do good, and spread goodness. We are a democratic, self-sustaining, two-sided marketplace which thrives on trust and is built on community and quality content.</p>
                        <div class="words_about_us_inner">
                            <div class="words_about_us_inner_img">
                                <img src="imeges/Desktop-3/Words About Us icon.png" class="w-100" alt=""/>
                            </div>
                            <div class="words_about_us_inner_text">
                                <h5>Phillip William</h5>
                                <p>Founder</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default WordsAboutUs